module.exports = __webpack_public_path__ + "static/Mavenlink-32c4f31adcc479958abb225a1a3f9ddd.png";